import { queryOptions } from '@tanstack/react-query';
import { fetchMediations } from '@/entities/mediation/api/requests.ts';
import { QUERY_KEYS, STALE_TIME_SHORT } from '@/app/api/constants.ts';
import { MediationQueryType } from '@/entities/mediation/api/types.ts';
import { authStore } from '@/app/localStorage/utils.ts';

export const fetchMediationsOptions = (queryParam?: MediationQueryType) => {
  const token = authStore.getToken();
  return queryOptions({
    queryKey: [QUERY_KEYS.FETCH_MEDIATIONS, queryParam, token],
    queryFn: () => fetchMediations(queryParam),
    staleTime: STALE_TIME_SHORT,
    refetchOnWindowFocus: true,
    enabled: !!token,
  });
};
